var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollectbookTagToon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 16,
    viewBox: "0 0 43 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_collectbook_tag_toon",
    clipPath: "url(#clip0_11155_217816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18164 0.727273C4.16502 0.727273 0.908913 3.98338 0.908913 8C0.908913 12.0166 4.16502 15.2727 8.18164 15.2727H34.3635C38.3801 15.2727 41.6362 12.0166 41.6362 8C41.6362 3.98338 38.3801 0.727273 34.3635 0.727273H8.18164ZM0.181641 8C0.181641 3.58172 3.76336 0 8.18164 0H34.3635C38.7817 0 42.3635 3.58172 42.3635 8C42.3635 12.4183 38.7817 16 34.3635 16H8.18164C3.76336 16 0.181641 12.4183 0.181641 8Z",
    fill: "#938F8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x8B\xB5\xEB\xB3\x80\xEB\x8C\x80\xEA\xB8\xB0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4605 8.41468V9.2883H26.0524V10.6902H24.9785V9.2883H21.3908V8.41468H29.4605ZM22.368 12.2959V9.91675H23.4523V11.4154H28.5697V12.2959H22.368ZM22.4129 7.82076V3.94645H28.4833V4.79589H23.504V5.46578H28.2658V6.29106H23.504V6.97476H28.5489V7.82076H22.4129Z",
    fill: "#938F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5725 3.64258V9.08457H19.5297V3.64258H20.5725ZM12.9033 6.9644C14.0808 6.9644 16.0283 6.94023 17.4682 6.71924L17.5408 7.44437C16.9986 7.56178 16.4012 7.6412 15.8073 7.68954V9.03968H14.7611V7.75515C14.1084 7.78277 13.4972 7.78277 13.0069 7.78277L12.9033 6.9644ZM13.3039 5.26205C13.3039 4.44714 14.0808 3.9499 15.241 3.9499C16.3943 3.9499 17.1782 4.44714 17.1782 5.26205C17.1782 6.06316 16.3943 6.58111 15.241 6.58111C14.0808 6.58111 13.3039 6.06316 13.3039 5.26205ZM14.2914 5.26205C14.288 5.62808 14.6506 5.81454 15.241 5.81454C15.8246 5.81454 16.2044 5.62808 16.2079 5.26205C16.2044 4.89948 15.8246 4.70266 15.241 4.70611C14.6506 4.70266 14.288 4.89948 14.2914 5.26205ZM14.3847 12.358V9.37462H15.4586V10.0445H19.4917V9.37462H20.5725V12.358H14.3847ZM15.4586 11.5121H19.4917V10.8801H15.4586V11.5121ZM16.4703 8.70128V7.95888H17.8757V3.79451H18.9012V9.0673H17.8757V8.70128H16.4703Z",
    fill: "#938F8F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11155_217816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1818,
    height: 16,
    fill: "white",
    transform: "translate(0.181641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollectbookTagToon);
export default __webpack_public_path__ + "static/media/icon_collectbook_tag_toon.a8a15820ef82d6852c601b02d2093c68.svg";
export { ForwardRef as ReactComponent };